import React, { Suspense } from 'react'
import { BrowserRouter, Redirect, Route } from 'react-router-dom'

import CabecalhoSistema from '../cabecalhoSistema'
import BreadCrumbs from '../components/BreadCrumbs/BreadCrumbs'
import '../components/clickstreamAnalise/clickstreamColeta.js'
import TelaLogin from '../components/login/login'
import logout from '../components/logout/logout'
import TelaInicial from '../components/telaInicial/telaInicial'
import NavegacaoSistema from '../navegacaoSistema'
import routers from '../statics/routers.json'
import { ResetOnRouteChange } from '../utils/ResetOnRouteChange.jsx'

// LAZY LOADING - em todas telas para serem renderizadas somente quando necessário
const DashboardGeral = React.lazy(
  () => import('../components/painelDashboard/dashboard')
)
const DashboardSMS = React.lazy(
  () => import('../components/painelDashboard/dashboardsms')
)
const DashboardPortadoras = React.lazy(
  () => import('../components/painelDashboard/Portadoras')
)
const DashboardFaturas = React.lazy(
  () => import('../components/painelFaturas/fatDashboard/dashboard')
)
const MigracaoPlanoDashboard = React.lazy(
  () => import('../components/painelVirtueyes/migracaoPlano/dashboard/index.js')
)

const TabelaDispositivos = React.lazy(
  () => import('../components/painelDispositivos/dspSimcard/tabelaSimcard')
)
const TabelaPortadoras = React.lazy(() => import('../pages/portadoras'))

const TabelaFatSolicitacoes = React.lazy(
  () => import('../components/painelFaturas/fatSolicitacoes/tabela')
)
const TabelaConectSolicitacoes = React.lazy(
  () => import('../components/painelFaturas/conectSolicitacoes/tabela')
)
const TabelaSimcardPedidos = React.lazy(
  () => import('../components/painelPedidos/pedidosSimcard/tabela')
)

const TabelaFinanceiro = React.lazy(
  () => import('../components/painelFinanceiro/tabela')
)
const PainelRelatorio = React.lazy(
  () => import('../components/painelRelatorio/tabela')
)
const clickstreamAnalise = React.lazy(
  () => import('../components/clickstreamAnalise/clickstreamAnalise.js')
)

//#region Painel Administrativo
const TabelaAcessoLog = React.lazy(
  () => import('../components/painelAdministrativo/logs/acessoLog/tabela')
)
const TabelaImeiLog = React.lazy(
  () => import('../components/painelAdministrativo/logs/imeiLog/tabela')
)
const TabelaRequestLog = React.lazy(
  () => import('../components/painelAdministrativo/logs/requestLog/tabela')
)
const TabelaCliente = React.lazy(
  () => import('../components/painelAdministrativo/pavCliente/tabela')
)
const TabelaCrudRBAC = React.lazy(
  () => import('../components/painelAdministrativo/pavCrudRBAC/tabela')
)
const TabelaElemento = React.lazy(
  () => import('../components/painelAdministrativo/pavElemento/tabela')
)
const TabelaGit = React.lazy(
  () => import('../components/painelAdministrativo/pavGit/tabela')
)
const TabelaMenu = React.lazy(
  () => import('../components/painelAdministrativo/pavMenu/tabela')
)
const TabelaModulo = React.lazy(
  () => import('../components/painelAdministrativo/pavModulo/tabela')
)
const TabelaParceiro = React.lazy(
  () => import('../components/painelAdministrativo/pavParceiro/tabela')
)
const TabelaPerfil = React.lazy(
  () => import('../components/painelAdministrativo/pavPerfil/tabela')
)
const CadastroPermissao = React.lazy(
  () => import('../components/painelAdministrativo/pavPermissao/cadastro')
)
const TabelaSistema = React.lazy(
  () => import('../components/painelAdministrativo/pavSistema/tabela')
)
const TabelaTela = React.lazy(
  () => import('../components/painelAdministrativo/pavTela/tabela')
)
const TabelaUsuario = React.lazy(
  () => import('../components/painelAdministrativo/pavUsuario/tabela')
)
const TabelaVersionamento = React.lazy(
  () => import('../components/painelAdministrativo/pavVersionamento/tabela')
)
//#endregion

const TabelaAutomacao = React.lazy(
  () => import('../components/painelAutomacao/tabelaAutomacao')
)
const PainelCadastroCliente = React.lazy(
  () => import('../components/painelCadastros/cadCliente/tabela')
)
const TabelaCadastroPerfil = React.lazy(
  () => import('../components/painelCadastros/perfil/tabela')
)
const TabelaMensagens = React.lazy(
  () => import('../components/painelMensagens/tabela')
)
const TabelaNovoPedidoSms = React.lazy(
  () => import('../components/painelPedidos/pedidosSms/tabela')
)
const TabelaLinhasRestTrucks = React.lazy(
  () => import('../components/painelResetTrucks/tabela')
)
const TabelaMensagensSms = React.lazy(
  () => import('../components/painelSms/smsMensagens/tabela')
)
const TabelaTemplateSms = React.lazy(
  () => import('../components/painelSms/smsTemplate/tabela')
)
const PainelTutoriais = React.lazy(
  () => import('../components/painelTutoriais')
)
const TabelaUsuarioCliente = React.lazy(
  () => import('../components/painelUsuarios/tabela')
)

//#region Painel Faturas
const FaturasCadastroCicloVida = React.lazy(
  () => import('../components/painelFaturas/fatCicloVida/tabela')
)
const FatConciliacao = React.lazy(
  () => import('../components/painelFaturas/fatConciliacao/tabela')
)
const FaturasCadastroContas = React.lazy(
  () => import('../components/painelFaturas/fatContas/tabela')
)
const FatContestacao = React.lazy(
  () => import('../components/painelFaturas/fatContestacao/tabela')
)
const TabelaDispostiviosFaturas = React.lazy(
  () => import('../components/painelFaturas/fatDispositivos/tabela')
)
const FaturasCadastroEmpresas = React.lazy(
  () => import('../components/painelFaturas/fatEmpresas/tabela')
)
const FatFaturas = React.lazy(
  () => import('../components/painelFaturas/fatFaturas/tabela')
)
const FatTabelaFebraban = React.lazy(
  () => import('../components/painelFaturas/fatFebraban/tabela')
)
const FatTabelaFornecedores = React.lazy(
  () => import('../components/painelFaturas/fatFornecedores/tabela')
)
const FatTabelaOperadoras = React.lazy(
  () => import('../components/painelFaturas/fatOperadoras/tabela')
)
const FaturasPedidos = React.lazy(
  () => import('../components/painelFaturas/fatPedidos/tabela')
)
const FatTabelaPlanos = React.lazy(
  () => import('../components/painelFaturas/fatPlanos/tabela')
)
const FatRelatorios = React.lazy(
  () => import('../components/painelFaturas/fatRelatorios/tabela')
)
const FatTabelaServico = React.lazy(
  () => import('../components/painelFaturas/fatServico/tabela')
)
const trial = React.lazy(
  () => import('../components/painelFaturas/fatTrial/trial')
)
//#endregion

//#region Painel Virtueyes
const TabelaCentralMensagens = React.lazy(
  () => import('../components/painelVirtueyes/centralMensagens/tabela')
)
const MigracaoPlanoGerenciamento = React.lazy(
  () => import('../components/painelVirtueyes/migracaoPlano/tabela')
)
const TabelaPedidoSmS = React.lazy(
  () => import('../components/painelVirtueyes/pedidoSms/tabelaPedidoSms')
)
const TabelaBloqueioAcoes = React.lazy(
  () => import('../components/painelVirtueyes/solicitacaoBloqueio/tabela')
)
const TabelaClientesAcoes = React.lazy(
  () => import('../components/painelVirtueyes/solicitacaoCliente/tabela')
)
const TabelaOperadoraAcoes = React.lazy(
  () => import('../components/painelVirtueyes/solicitacaoOperadora/tabela')
)
const TabelaClientes = React.lazy(
  () =>
    import('../components/painelVirtueyes/virtuTabelaClientes/tabelaClientes')
)
//#endregion

//#region Páginas
const ActivationSimcard = React.lazy(() => import('../pages/demo/expoSec.jsx'))
const LoginActivation = React.lazy(
  () => import('../pages/demo/loginActivation.jsx')
)
const ESimDevices = React.lazy(() => import('../pages/eSims/devices.jsx'))
const ESimsStock = React.lazy(() => import('../pages/eSims/stock.jsx'))
const TabelaSimcardsVirgens = React.lazy(
  () => import('../pages/simcards-virgens/index.jsx')
)
const TabelaESims = React.lazy(
  () => import('../pages/solicitacoes/e-sims/index.jsx')
)
const SimcardsVirgensSolicitacoes = React.lazy(
  () => import('../pages/solicitacoes/simcards-virgens/index.jsx')
)
//#endregion

const LoadingFallback = () => null
/* (
  <div className="componente-spinner-overlay">
    <div className="componente-spinner-container">
      <SpinerVeye />
    </div>
  </div>
) */

const PrivateRoute = ({ component: Component, ...rest }) => {
  const hasToken = localStorage.getItem('@veye-Token')

  return (
    <Route
      exact
      {...rest}
      render={(props) =>
        hasToken ? (
          <Suspense fallback={<LoadingFallback />}>
            <Component {...props} />
          </Suspense>
        ) : (
          <Redirect
            to={{ pathname: routers.login, state: { from: props.location } }}
          />
        )
      }
    />
  )
}

export default function Routers() {
  return (
    <BrowserRouter>
      <ResetOnRouteChange />
      <Route
        path={routers.login}
        exact
        render={() => {
          const hasToken = localStorage.getItem('@veye-Token')
          return hasToken ? <Redirect to="/veye" /> : <TelaLogin />
        }}
      />
      <Route path="/" exact>
        <Redirect from="/" to={routers.telaInicial} />
      </Route>
      <Route path={routers.logout} exact component={logout} />
      <Route
        path={routers.trial}
        render={(props) => {
          const Trial = trial
          return (
            <Suspense fallback={<LoadingFallback />}>
              <Trial {...props} />
            </Suspense>
          )
        }}
      />
      <Route
        path={routers.demo.activationSimcard}
        render={(props) => (
          <Suspense fallback={<LoadingFallback />}>
            <ActivationSimcard {...props} />
          </Suspense>
        )}
      />
      <Route
        path={routers.demo.loginActivation}
        render={(props) => (
          <Suspense fallback={<LoadingFallback />}>
            <LoginActivation {...props} />
          </Suspense>
        )}
      />
      <Route
        path={routers.telaInicial}
        render={() =>
          localStorage.getItem('@veye-Token') ? (
            <>
              <NavegacaoSistema />
              <div id="container-tela">
                <CabecalhoSistema />
                <div id="container-corpo">
                  <BreadCrumbs />
                  <PrivateRoute
                    path={routers.telaInicial}
                    component={TelaInicial}
                  />
                  <PrivateRoute
                    path={routers.dispositivos}
                    component={TabelaDispositivos}
                  />
                  <PrivateRoute
                    path={routers.painelSistema}
                    component={TabelaSistema}
                  />
                  <PrivateRoute
                    path={routers.painelModulo}
                    component={TabelaModulo}
                  />
                  <PrivateRoute
                    path={routers.painelTela}
                    component={TabelaTela}
                  />
                  <PrivateRoute
                    path={routers.painelElemento}
                    component={TabelaElemento}
                  />
                  <PrivateRoute
                    path={routers.painelUsuarios}
                    component={TabelaUsuario}
                  />
                  <PrivateRoute
                    path={routers.tabelaVersoes}
                    component={TabelaVersionamento}
                  />
                  <PrivateRoute
                    path={routers.painelVersionamento}
                    component={TabelaVersionamento}
                  />
                  <PrivateRoute
                    path={routers.painelGit}
                    component={TabelaGit}
                  />
                  <PrivateRoute
                    path={routers.painelClientes}
                    component={TabelaCliente}
                  />
                  <PrivateRoute
                    path={routers.painelParceiros}
                    component={TabelaParceiro}
                  />
                  <PrivateRoute
                    path={routers.painelPapeis}
                    component={TabelaCrudRBAC}
                  />
                  <PrivateRoute
                    path={routers.painelPerfil}
                    component={TabelaPerfil}
                  />
                  <PrivateRoute
                    path={routers.painelRequestLog}
                    component={TabelaRequestLog}
                  />
                  <PrivateRoute
                    path={routers.painelAcessoLog}
                    component={TabelaAcessoLog}
                  />
                  <PrivateRoute
                    path={routers.painelPermissoes}
                    component={CadastroPermissao}
                  />
                  <PrivateRoute
                    path={routers.painelClickstreamAnalise}
                    component={clickstreamAnalise}
                  />
                  <PrivateRoute
                    path={routers.virtueyesClientes}
                    component={TabelaClientes}
                  />
                  <PrivateRoute
                    path={routers.virtueyesCentralMensagens}
                    component={TabelaCentralMensagens}
                  />
                  <PrivateRoute
                    path={routers.virtueyesPedidosSMS}
                    component={TabelaPedidoSmS}
                  />
                  <PrivateRoute
                    path={routers.virtueyesMigracaoPlanoGerenciamento}
                    component={MigracaoPlanoGerenciamento}
                  />
                  <PrivateRoute
                    path={routers.virtueyesMigracaoPlanoDashboard}
                    component={MigracaoPlanoDashboard}
                  />
                  <PrivateRoute
                    path={routers.virtueyesClientesAcoes}
                    component={TabelaClientesAcoes}
                  />
                  <PrivateRoute
                    path={routers.virtueyesOperadoraAcoes}
                    component={TabelaOperadoraAcoes}
                  />
                  <PrivateRoute
                    path={routers.virtueyesBloqueioAcoes}
                    component={TabelaBloqueioAcoes}
                  />
                  <PrivateRoute
                    path={routers.smsMensagens}
                    component={TabelaMensagensSms}
                  />
                  <PrivateRoute
                    path={routers.smsTemplate}
                    component={TabelaTemplateSms}
                  />
                  <PrivateRoute
                    path={routers.pedidosSms}
                    component={TabelaNovoPedidoSms}
                  />
                  <PrivateRoute
                    path={routers.pedidosSimcard}
                    component={TabelaSimcardPedidos}
                  />
                  <PrivateRoute
                    path={routers.financeiro}
                    component={TabelaFinanceiro}
                  />
                  <PrivateRoute
                    path={routers.dashboardDispositivos}
                    component={DashboardGeral}
                  />
                  <PrivateRoute
                    path={routers.dashboardSMS}
                    component={DashboardSMS}
                  />
                  <PrivateRoute
                    path={routers.dashboardPortadoras}
                    component={DashboardPortadoras}
                  />
                  <PrivateRoute
                    path={routers.automacao}
                    component={TabelaAutomacao}
                  />
                  <PrivateRoute
                    path={routers.tutoriais}
                    component={PainelTutoriais}
                  />
                  <PrivateRoute
                    path={routers.mensagens}
                    component={TabelaMensagens}
                  />
                  <PrivateRoute
                    path={routers.usuarios}
                    component={TabelaUsuarioCliente}
                  />
                  <PrivateRoute
                    path={routers.faturasPedidos}
                    component={FaturasPedidos}
                  />
                  <PrivateRoute
                    path={routers.faturasContas}
                    component={FaturasCadastroContas}
                  />
                  <PrivateRoute
                    path={routers.faturasFebraban}
                    component={FatTabelaFebraban}
                  />
                  <PrivateRoute
                    path={routers.faturasEmpresas}
                    component={FaturasCadastroEmpresas}
                  />
                  <PrivateRoute
                    path={routers.faturasPlanos}
                    component={FatTabelaPlanos}
                  />
                  <PrivateRoute
                    path={routers.faturasServicos}
                    component={FatTabelaServico}
                  />
                  <PrivateRoute
                    path={routers.faturasCicloVida}
                    component={FaturasCadastroCicloVida}
                  />
                  <PrivateRoute
                    path={routers.faturasOperadoras}
                    component={FatTabelaOperadoras}
                  />
                  <PrivateRoute
                    path={routers.solicitacoesFaturas}
                    component={TabelaFatSolicitacoes}
                  />
                  <PrivateRoute
                    path={routers.solicitacoesSimcardsEmBranco}
                    component={SimcardsVirgensSolicitacoes}
                  />
                  <PrivateRoute
                    path={routers.solicitacoesESims}
                    component={TabelaESims}
                  />
                  <PrivateRoute
                    path={routers.solicitacoesConectividade}
                    component={TabelaConectSolicitacoes}
                  />
                  <PrivateRoute
                    path={routers.faturasDispositivos}
                    component={TabelaDispostiviosFaturas}
                  />
                  <PrivateRoute
                    path={routers.faturasFornecedores}
                    component={FatTabelaFornecedores}
                  />
                  <PrivateRoute
                    path={routers.faturasFaturas}
                    component={FatFaturas}
                  />
                  <PrivateRoute
                    path={routers.faturasConciliacao}
                    component={FatConciliacao}
                  />
                  <PrivateRoute
                    path={routers.faturasContestacao}
                    component={FatContestacao}
                  />
                  <PrivateRoute
                    path={routers.faturasDashboard}
                    component={DashboardFaturas}
                  />
                  <PrivateRoute
                    path={routers.faturasRelatorios}
                    component={FatRelatorios}
                  />
                  <PrivateRoute
                    path={routers.painelRelatorios}
                    component={PainelRelatorio}
                  />
                  <PrivateRoute
                    path={routers.painelImeiLog}
                    component={TabelaImeiLog}
                  />
                  <PrivateRoute
                    path={routers.painelMenu}
                    component={TabelaMenu}
                  />
                  <PrivateRoute
                    path={routers.cadastroPerfil}
                    component={TabelaCadastroPerfil}
                  />
                  <PrivateRoute
                    path={routers.cadastroCliente}
                    component={PainelCadastroCliente}
                  />
                  <PrivateRoute
                    path={routers.portalCliente}
                    component={PainelCadastroCliente}
                  />
                  <PrivateRoute
                    path={routers.linhasReset}
                    component={TabelaLinhasRestTrucks}
                  />
                  <PrivateRoute
                    path={routers.simcardsEmBranco}
                    component={TabelaSimcardsVirgens}
                  />
                  <PrivateRoute
                    path={routers.portadoras}
                    component={TabelaPortadoras}
                  />
                  <PrivateRoute
                    path={routers.eSimDevices}
                    component={ESimDevices}
                  />
                  <PrivateRoute
                    path={routers.eSimStock}
                    component={ESimsStock}
                  />
                </div>
              </div>
            </>
          ) : (
            <Redirect to={{ pathname: '/login' }} />
          )
        }
      />
    </BrowserRouter>
  )
}
